import React from 'react';
import { Link } from 'react-router-dom';

import _ from 'lodash';
import $ from 'jquery';
import { toast } from 'react-toastify';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import SubLayout from '../../components/Layout/SubLayout'
import strings from "./../../components/Language";
import { getToken, storeUserData } from './../../components/Util';
import LoaderContext from '../../components/Loader/LoaderContext.js';

import { api } from '../../components/config/api.js';
import axios from 'axios';

class AutoTradeScreen extends React.Component {
    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.state = {
            lang: strings.getLanguage(),
            access_token: "",
            data: [],
            onStartloading: false,
            onStoploading: false,
            selectedBots: [],
            selectedMaxPairs: 3,
            // botOptions: ['DCA', 'AI', 'CTS'],
            botOptions: [
                { id: 0, value: 2, name: 'AI' },
                { id: 1, value: 0, name: 'CTS' },
            ],
            checkedList: [],
            maxPairsOptions: [
                { label: '1', value: '1' },
                { label: '2', value: '2' },
                { label: '3', value: '3' },
                { label: '4', value: '4' },
                { label: '5', value: '5' },
                { label: '6', value: '6' },
                { label: '7', value: '7' },
                { label: '8', value: '8' },
                { label: '9', value: '9' },
                { label: '10', value: '10' }
            ],
            isStart: false
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            this.setState({ access_token: token });
            setTimeout(() => {
                this.getData();
            });
        }
    }

    getData() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            setLoading(true);
            axios({
                method: 'GET',
                url: api.auto_trade,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                    self.setState({
                        data: ress.data.data,
                        selectedMaxPairs: ress.data.data.max_pairs || 3,
                        isStart: ress.data.data.status,
                        selectedBots: ress.data.data.bots.map((bot) => {
                            return self.state.botOptions.findIndex((option) => option.value === bot);
                        }).filter((index) => index !== -1),
                    });
                }
                setLoading(false);
                self.setState({ is_load: false });
            }).catch(function (e) {
                self.setState({ is_load: false });
                setLoading(false);
            });
        }
    };

    selectBot = (index) => {
        this.setState({
            selectedBots: [index]
        });
    };

    onStartConfirm() {
        var self = this;
        if (this.state.onStartloading) {
            return false;
        }
        $.confirm({
            title: strings.confirm + '!',
            theme: 'dark',
            content: strings.are_you_sure_you + " want to start AI Trade",
            buttons: {
                somethingElse: {
                    text: strings.start,
                    btnClass: 'btn-success',
                    action: function () {
                        self.onFinish(api.auto_trade_store, 1);
                    }
                },
                cancel: function () {
                    //close
                },
            }
        });
    }

    onStop() {
        this.onFinish(api.auto_trade_store, 0);
    }

    onFinish(api_url, status = null) {
        const { setLoading } = this.context;
        var self = this;
        if (status === 1 && self.state.selectedBots.length === 0) {
            toast.error(strings.please_select_one_bot);
            return false;
        }
        if (self.state.access_token && api_url && status != null) {
            self.setState({ onStartloading: true });
            setLoading(true);

            var json = {
                bots: this.state.selectedBots.map((index) => this.state.botOptions[index].value),
                max_pairs: this.state.selectedMaxPairs,
                status: status
            }

            axios({
                method: 'POST',
                url: api_url,
                data: json,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage(),
                }
            }).then(function (ress) {
                setLoading(false);
                if (ress.data && ress.data.error === 200) {
                    toast.success(ress.data.message);
                    self.getData();
                    self.props.history.replace({ pathname: `/home` })
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                }
                self.setState({ onStartloading: false });
            }).catch(function (e) {
                setLoading(false);
                self.setState({ onStartloading: false });
            });
        }
    }



    render() {
        const { selectedBots } = this.state;
        const isStart = this.state.isStart === true || this.state.isStart === 1;
        return (
            <SubLayout data={{ "title": strings.AutoTrade }}>
                <div className='m-page'>
                    <div className='m-card'>
                        <div className='m-label'>{strings.Select_BOT}</div>
                        <div className='m-options'>
                            {this.state.botOptions.map((option, index) => {
                                const active = selectedBots.includes(index);
                                return (
                                    <label key={`SELECT_BOT_${index}`} className={'m-option' + (active ? ' active' : '')}>
                                        <input
                                            type="radio"
                                            name="auto_trade_bot"
                                            value={option.name}
                                            checked={active}
                                            onChange={() => this.selectBot(index)}
                                        />
                                        <span className='m-option-dot' />
                                        <span className='m-option-text'>{option.name}</span>
                                    </label>
                                );
                            })}
                        </div>

                        <div className='m-label'>{strings.Max_Pairs}</div>
                        <div className='main_content m-select'>
                            <Select
                                value={this.state.selectedMaxPairs}
                                name={strings.Select_Max_Pairs}
                                style={{ width: "100%" }}
                                onChange={(e) => this.setState({ selectedMaxPairs: e.target.value })}
                            >
                                {this.state.maxPairsOptions.map((item) => (
                                    <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                                ))}
                            </Select>
                        </div>

                        <div className='m-label'>{strings.status}</div>
                        <div className='m-options'>
                            <label className={'m-option up' + (isStart ? ' active' : '')}>
                                <input type="radio" name="status" value="start" checked={isStart} onChange={() => this.setState({ isStart: 1 })} />
                                <span className='m-option-dot' />
                                <span className='m-option-text'>{strings.start}</span>
                            </label>
                            <label className={'m-option down' + (!isStart ? ' active' : '')}>
                                <input type="radio" name="status" value="stop" checked={!isStart} onChange={() => this.setState({ isStart: 0 })} />
                                <span className='m-option-dot' />
                                <span className='m-option-text'>{strings.stop}</span>
                            </label>
                        </div>

                        <button
                            type="button"
                            className='m-btn m-btn-primary'
                            disabled={this.state.onStartloading}
                            onClick={() => isStart ? this.onStartConfirm() : this.onStop()}
                        >
                            {this.state.onStartloading ? strings.loading : strings.save}
                        </button>

                        <div className='m-note'>
                            <div className='m-note-title'>{strings.disclaimer}</div>
                            <div>{strings.auto_trade_disclaimer}</div>
                        </div>
                    </div>
                </div>
            </SubLayout >
        );
    }
}

export default AutoTradeScreen;
